export default {"src":"/_next/static/media/polygon.31cd4257.svg","height":24,"width":24};